import { useRouteLoaderData } from "react-router";

export function useEnv() {
  const { env } = useRouteLoaderData("root");
  return env;
}
